var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Button, ConfirmationModal, ErrorModal, MenuSection, Pane, } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import NavComponent from "../../components/NavComponent";
import TableComponent from "../../components/TableComponent";
import PublisherPrefixRangeDetail from "./PublisherPrefixRangeDetail";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { usePublisherPrefixRangeFilters } from "../../hooks/usePublisherPrefixRangeFilters";
import { usePublisherPrefixRangeData } from "../../hooks/usePublisherPrefixRangeData";
import { usePublisherPrefixRangeTable } from "../../hooks/usePublisherPrefixRangeTable";
import { usePublisherPrefixRangeActions } from "../../hooks/usePublisherPrefixRangeActions";
import { PublisherPrefixRangeFilters } from "../../components/PublisherPrefixRangeFilters";
import { usePageSize } from "../../hooks/usePageSize";
var PublisherPrefixRangeList = function () {
    var history = useHistory();
    var formatMessage = useIntl().formatMessage;
    var _a = useState(true), filterPaneIsVisible = _a[0], setFilterPaneIsVisible = _a[1];
    var filtersHook = usePublisherPrefixRangeFilters();
    var _b = usePageSize(), pageSize = _b.pageSize, createPageSizeHandler = _b.createPageSizeHandler;
    var dataHook = usePublisherPrefixRangeData(filtersHook.filters, pageSize);
    var actionsHook = usePublisherPrefixRangeActions();
    var columns = usePublisherPrefixRangeTable(actionsHook.handleRowClick).columns;
    var toggleFilterPane = function () { return setFilterPaneIsVisible(function (prev) { return !prev; }); };
    var handlePageSizeChange = createPageSizeHandler(dataHook.fetchMoreData);
    var handleApplyFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleFilterApply();
    };
    var handleClearFilters = function () {
        dataHook.resetPageOffset();
        filtersHook.handleClearFilters();
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(RecekPaneSet, null,
            React.createElement(ErrorModal, { open: actionsHook.errorOpen, label: formatMessage({ id: "ui-br-agency.modal.label.error" }), content: actionsHook.errorMessage, onClose: actionsHook.closeErrorModal }),
            React.createElement(ConfirmationModal, { open: actionsHook.showConfirmModal, heading: actionsHook.confirmMessage
                    ? formatMessage({ id: "ui-br-agency.modal.heading.result" })
                    : formatMessage({ id: "ui-br-agency.modal.heading.confirm" }), message: actionsHook.confirmMessage || actionsHook.modalMessage, onConfirm: actionsHook.confirmMessage
                    ? actionsHook.closeConfirmModal
                    : function () { return __awaiter(void 0, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, actionsHook.handleConfirm(dataHook.refetch)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); }, onCancel: actionsHook.closeConfirmModal, confirmLabel: actionsHook.confirmMessage
                    ? formatMessage({ id: "ui-br-agency.button.ok" })
                    : formatMessage({ id: "ui-br-agency.yes" }), cancelLabel: !actionsHook.confirmMessage &&
                    formatMessage({ id: "ui-br-agency.no" }), buttonStyle: "primary" }),
            filterPaneIsVisible && (React.createElement(Pane, { id: "menuPane", defaultWidth: "25%", paneTitle: formatMessage({
                    id: "ui-br-agency.pane.title.navigation.and.filtering",
                }) },
                React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                    React.createElement(NavComponent, null),
                    React.createElement(Button, { buttonStyle: "none", id: "clickable-reset-all", marginBottom0: true, onClick: handleClearFilters, disabled: !filtersHook.isAnyFilterActive },
                        React.createElement(FormattedMessage, { id: "ui-br-agency.button.resetAll" })),
                    React.createElement(PublisherPrefixRangeFilters, { agencyPrefixesOptions: filtersHook.agencyPrefixesOptions, agencyPrefixFilter: filtersHook.agencyPrefixFilter, showClosedFilter: filtersHook.showClosedFilter, onAgencyPrefixFilterChange: filtersHook.setAgencyPrefixFilter, onShowClosedFilterChange: filtersHook.setShowClosedFilter, onApplyFilters: handleApplyFilters })))),
            React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher-prefix-range.pane.title.list",
                }), actionMenu: function (_a) {
                    var onToggle = _a.onToggle;
                    return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-agency.action.menu.label" }), id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                onToggle();
                                history.push("/bragency/publisher-prefix-ranges/create");
                            } },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.create" }))));
                } },
                React.createElement(TableComponent, { data: dataHook.items, columns: columns, pageSize: pageSize, onPageSizeChange: handlePageSizeChange, totalCount: dataHook.totalRecords, pagingOffset: dataHook.pageOffset, onNeedMoreData: function (offset) { return dataHook.fetchMoreData(offset); }, searchTerm: "", filterPaneIsVisible: filterPaneIsVisible, toggleFilterPane: toggleFilterPane, source: dataHook.source })),
            actionsHook.selectedPublisherPrefix && (React.createElement(Pane, { id: "detailPane", defaultWidth: "35%", paneTitle: formatMessage({
                    id: "ui-br-agency.publisher-prefix-range.pane.title.detail",
                }), onClose: actionsHook.handleCloseDetail, dismissible: true, actionMenu: function () {
                    var _a;
                    return (React.createElement(MenuSection, { label: formatMessage({ id: "ui-br-agency.action.menu.label" }), id: "actions-menu" },
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                var _a;
                                return history.push("/bragency/publisher-prefix-ranges/edit/".concat((_a = actionsHook.selectedPublisherPrefix) === null || _a === void 0 ? void 0 : _a.id));
                            }, fullWidth: true },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.edit" })),
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                return actionsHook.openConfirmModalDelete(actionsHook.selectedPublisherPrefix);
                            }, fullWidth: true },
                            React.createElement(FormattedMessage, { id: "ui-br-agency.button.delete" })),
                        React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                                return actionsHook.openConfirmModalToggle(actionsHook.selectedPublisherPrefix);
                            }, fullWidth: true }, ((_a = actionsHook.selectedPublisherPrefix) === null || _a === void 0 ? void 0 : _a.status) === "ACTIVE"
                            ? formatMessage({ id: "ui-br-agency.button.close" })
                            : formatMessage({ id: "ui-br-agency.button.open" }))));
                } },
                React.createElement(PublisherPrefixRangeDetail, { prefixRange: actionsHook.selectedPublisherPrefix }))))));
};
export default PublisherPrefixRangeList;
